module.exports = __webpack_public_path__ + "static/media/austrian.14d4460c.png";